<template>
  <div
    id="about-candidate"
    class="create-profile-step-container"
  >
    <step-title
      :title="title"
      :subtitle="subtitle"
      :icon="icon"
    />
    <div class="columns">
      <div class="column">
        <p class="is-size-7 has-text-grey has-text-right">
          {{ charactersLeft }} Characters Left
        </p>
        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <div class="control">
                <textarea
                  v-model="bio"
                  v-validate="'required'"
                  name="aboutCandidate"
                  class="textarea"
                  :maxlength="aboutFieldMax"
                  placeholder="I'm a go-getter with a heart of gold..."
                  @keyup="updateBio()"
                />
                <p class="help is-danger">
                  {{ errors.first(`aboutCandidate`) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepTitle from './StepTitle';
import { profileValidationConstants } from '@/helpers/constants';

export default {
  name: 'AboutCandidate',
  components: {
    StepTitle
  },
  data () {
    return {
      title: 'About Me',
      subtitle:
        'Write a short description of who you are and what you have to offer.',
      icon: 'fa-user',
      bio: '',
      aboutFieldMax: 0
    };
  },
  computed: {
    isFormValid () {
      return Object.keys(this.fields).every(key => this.fields[key].valid);
    },
    charactersLeft () {
      return profileValidationConstants.ABOUT_CANDIDATE_MAX - this.bio.length;
    }
  },
  created () {
    this.bio = this.$store.state.user.profile.bio;
    this.aboutFieldMax = profileValidationConstants.ABOUT_CANDIDATE_MAX;
  },
  mounted () {
    this.checkForm();
  },
  methods: {
    updateBio () {
      this.checkForm();
      this.$store.commit('EDIT_CANDIDATE_BIO', this.bio);
    },
    checkForm () {
      setTimeout(() => {
        this.$emit('checkForm', this.isFormValid);
      }, 50);
    }
  }
};
</script>

<style scoped lang="scss">
.step-description {
  margin-bottom: 2rem;
}
</style>
